import {LecturerProgram} from './lecturer-program.model'
import {AtividadeCadastroProgramaModel} from './atividade-cadastro-programa.model'

export class Activity {
    public AtividadeId: number;
    public AreaTematicaId: number;
    public AreaTematica: string;
    public AreaAbrangenciaId: number;
    public AreaAbrangencia: string;
    public InscritoNaAtividade: boolean;
    public PresenteNaAtividade: boolean;
    public InteresseNaAtividade: boolean;
    public SiglaSala: string;
    public DescritivoSala: string;
    public OrdemAtividade: number;
    public HoraInicioAtividade: string;
    public HoraFimAtividade: string;
    public TemaDaAtividade: string;
    public AtividadesCadastro: Array<AtividadeCadastroProgramaModel>;
    public PalestrantesId: string;
    public VagasSala: number;
    public VagasOcupadas: number;
    public VagasTotal: number;
    public VagasLimitadasOcupadas: number;
    public VagasLimitadasTotal: number;
    public VagasComparecidas: number;
    public Sigla: string;
    public Descricao: string;
    public DiaData: string;
    public Cor: string;
    public CorAtividade: string;
    public Palestrantes: Array<LecturerProgram>;
    public Area: string;
    public TemVideos: boolean;
    public Duracao: string;
}



// WEBPACK FOOTER //
// ./src/models/activity.model.ts